<template>
	<div id="app">
		<div id="app-wrapper">
			<!--<main :id="$route.name" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">-->
			<main :id="$route.name">
				<component :is="layout">
					<router-view :key="$route.fullPath"/>
				</component>
				<firstTimeAccess/>
			</main>
		</div>
	</div>
</template>

<script>

const defaultLayout = 'default';
import firstTimeAccess from '@/components/FirstTimeAccess';

export default {
	async created() {
		var self = this;
		document.addEventListener('backbutton', this.manageBackButton);
	},
	computed: {
		layout() {
			return (this.$route.meta.layout || defaultLayout) + '-layout';
		}
	},
	watch: {
		$route(to, from) {
			if (from.name === 'remote-control') {
				// let a = document.createElement("a");
				// a.href = to.path;
				// document.querySelector('body').appendChild(a);
				// a.click();
				// this.$router.push({path: to.path}, function() { alert("ciaone")});
				// next(false);

			}
		}
	},
	methods: {
		swipeLeft() {
			this.$store.dispatch('openMenu');
		},
		swipeRight() {
			if (this.$store.getters.isMenuOpen) {
				this.$store.dispatch('closeMenu');
			} else {
				this.$router.go(-1);
			}
		},
		manageBackButton() {
			if (this.$store.getters.isMenuOpen) {
				this.$store.dispatch('closeMenu');
			} else if (this.$route.name === 'home') {
				navigator.app.exitApp();
			} else {
				navigator.app.backHistory();
			}
		},
	},
	components:{
		firstTimeAccess,
	}
}
</script>

<style>
#app {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background: #ddd;
}

#app-wrapper {
	height: 100%;
	background: #fff;
}

@media screen and (min-width: 1440px) {
	#app {
		background: -moz-linear-gradient(top, var(--primary_color) calc(5vh + 7.2rem), #ddd calc(5vh + 7.2rem));
		background: -webkit-linear-gradient(top, var(--primary_color) calc(5vh + 7.2rem), #ddd calc(5vh + 7.2rem));
		background: linear-gradient(to bottom, var(--primary_color) calc(5vh + 7.2rem), #ddd calc(5vh + 7.2rem));
	}

	#app-wrapper {
		width: 90vw;
		margin: 5vh auto;
		height: 90vh;
		box-shadow: 0 0 4px rgba(0,0,0,0.2);
		border-radius: 3px;
		overflow: auto;
		min-height: 48rem;
	}
}

main {
	background-color: var(--body_background_color);
	height: 100%;
}

/*Fade*/
.fade-enter-active {
	transition: opacity .4s;
}

.fade-leave-active {
	transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

/*Slide up*/
.slide-up-enter-active {
	transition: transform .4s, opacity .4s;
}

.slide-up-leave-active {
	transition: opacity .2s;
}

.slide-up-enter {
	transform: translateY(4.0rem);
}

.slide-up-enter, .slide-up-leave-to {
	opacity: 0;
}

/*Slide down*/
.slide-down-enter-active {
	transition: transform .4s, opacity .4s;
}

.slide-down-leave-active {
	transition: opacity .2s;
}

.slide-down-enter {
	transform: translateY(-4.0rem);
}

.slide-down-enter, .slide-down-leave-to {
	opacity: 0;
}
</style>
